<template>
    <common-chart ref="chart" class="w-100 h-100" :options="generateOption" not-merge
                  :group-id="groupId"></common-chart>
</template>

<script>
import CommonChart from "@/components/echarts-part/kpi/stuff/CommonChart.vue";
import emCommonUtilMixin from "@/mixin/em/common/stuffs/utils/emCommonUtilMixin";

export default {
    name: "TableChart",
    components: {CommonChart},
    mixins: [emCommonUtilMixin],
    props: {
        xAxisItems: [Array, String],
        groupId: String,
        fieldList: Array
    },
    computed: {
        xAxisConfig() {
            if (this.xAxisItems === 'time') {
                return {
                    type: 'time',
                    axisLabel: {
                        formatter: {
                            hour: '{boldStyle|{HH}:{mm}}',
                            minute: '{boldStyle|{HH}:{mm}}',
                            second: '{secondStyle|{ss}s}',
                        },
                        rich: {
                            secondStyle: {
                                color: '#aaaaaa',
                            },
                            boldStyle: {
                                color: '#333',
                                fontWeight: 'bold'
                            }
                        }
                    }
                };
            } else {
                return {
                    data: this.xAxisItems
                }
            }
        },
        generateOption() {
            return {
                tooltip: {
                    trigger: (this.isPie || this.isStack) ? 'item' : 'axis',
                    axisPointer: this.isPie ? undefined : {
                        type: 'shadow'
                    }
                },
                grid: {
                    bottom: 30,
                    top: 30
                },
                toolbox: {
                    feature: {
                        dataZoom: {
                            yAxisIndex: 'none'
                        },
                        restore: {},
                        saveAsImage: {}
                    }
                },
                xAxis: this.isPie ? undefined : this.xAxisConfig,
                yAxis: this.isPie ? undefined : {
                    type: 'value'
                },
                legend: {
                    show: true,
                    type: 'scroll'
                },
                series: this.seriesList,
            };
        },
    },
    data() {
        return {
            option: {},
            chartConfigs: [],
            seriesList: [],
            isPie: false,
            isStack: false,
            tooltipTrigger: 'axis'
        }
    },
    watch: {
        fieldList: {
            handler() {
                if (!this.fieldList) {
                    return;
                }
                let tempList = JSON.parse(JSON.stringify(this.fieldList));
                this.isPie = false;
                for (let item of tempList) {
                    if (item.type === 'pie') {
                        item.emphasis = {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.5)'
                            }
                        };
                        item.radius = '70%';
                        item.top = 20;
                        this.isPie = true;
                    } else {
                        item.sampling = 'lttb';
                    }
                    this.isStack = this.hasCode(item.stack);
                }
                this.seriesList = tempList;
            },
            deep: true,
            immediate: true,
        }
    },
    methods: {
        resize() {
            this.$refs.chart.resize();
        },
    },
}
</script>

<style scoped>

</style>
